import { z } from 'zod';

export const AdminModalLawSchoolsFormSchema = z.object({
  name: z.string().min(1).max(250),
  tags: z.string().uuid().nullish(), // single rank tag id
});

export type AdminModalLawSchoolsFormValues = z.infer<
  typeof AdminModalLawSchoolsFormSchema
>;
